var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnAddComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20646",
    "data-name": "Grupo 20646",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_231",
    "data-name": "Elipse 231",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20641",
    "data-name": "Grupo 20641",
    transform: "translate(16.079 8.999) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_500",
    "data-name": "L\\xEDnea 500",
    x2: 11.426,
    y2: 11.426,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_501",
    "data-name": "L\\xEDnea 501",
    x1: 11.426,
    y2: 11.426,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAddComplete);
export default __webpack_public_path__ + "static/media/btn-add-complete.c4a3466e9f091fd5d732b40e072ff8cb.svg";
export { ForwardRef as ReactComponent };